var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckNegative = function SvgCheckNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zm14 25.1l-14.3 15c-1.4 1.5-3.7 1.5-5.2.2l-8.2-7.5c-1.5-1.4-1.6-3.8-.2-5.3s3.8-1.6 5.3-.2l5.5 5L38.7 20c1.4-1.5 3.8-1.5 5.3-.1s1.4 3.7 0 5.2z"
  })));
};
export default SvgCheckNegative;